"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterList = exports.Filter = exports.FilterDeletePayload = exports.FilterUpdatePayload = exports.FilterCreatePayload = exports.RegistrySearchPayload = exports.SearchFilterParams = exports.KeyValueFilter = exports.WhereNode = exports.SearchField = exports.SearchOperator = exports.RegistryUpdatePayload = exports.RegistryCreatePayload = exports.DevicePage = exports.Device = exports.ContactInfo = exports.InstallationAddress = exports.DeviceIdentity = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const field_1 = require("../../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
const optionalDateTime = (description) => effect_1.Schema.optionalWith((0, field_1.dateTime)(description), { exact: true }).annotations({ description });
// List, search and get return the stored value. An unregistered v1 device has
// null. A v2 device stores registeredAt as epoch milliseconds, and a registered
// v1 device is an ISO string after JSON serialization.
const recordTimestamp = (description) => effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Union((0, field_1.dateTime)(description), effect_1.Schema.Number)), { exact: true }).annotations({
    description,
});
exports.DeviceIdentity = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceIdentity`,
});
const addressFields = {
    address: (0, field_1.optionalNullableString)('Street address'),
    addressExtra: (0, field_1.optionalNullableString)('Additional address line'),
    zip: (0, field_1.optionalNullableString)('Postal code'),
    city: (0, field_1.optionalNullableString)('City'),
    state: (0, field_1.optionalNullableString)('State or province'),
    country: (0, field_1.optionalNullableString)('Country'),
    countryCode: (0, field_1.optionalNullableString)('Country code'),
    mobilePhoneNumber: (0, field_1.optionalNullableString)('Legacy contact phone copied from contactInfo by default'),
    contactName: (0, field_1.optionalNullableString)('Legacy contact name copied from contactInfo by default'),
    email: (0, field_1.optionalNullableString)('Legacy contact email copied from contactInfo by default'),
};
const contactFields = {
    phoneNumber: (0, field_1.optionalNullableString)('Contact phone number'),
    email: (0, field_1.optionalNullableString)('Contact email'),
    name: (0, field_1.optionalNullableString)('Contact name'),
    customerAccountId: (0, field_1.optionalNullableString)('Customer account id'),
};
exports.InstallationAddress = effect_1.Schema.Struct(addressFields).annotations({
    identifier: `${exports.NAMESPACE}.InstallationAddress`,
});
exports.ContactInfo = effect_1.Schema.Struct(contactFields).annotations({
    identifier: `${exports.NAMESPACE}.ContactInfo`,
});
exports.Device = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Stored device id'),
    serialNumber: (0, field_1.nonEmpty)('Device serial number (projected from id when absent)'),
    name: (0, field_1.optionalNullableString)('Device display name'),
    ownerId: (0, field_1.optionalNullableString)('Owner user id'),
    dealerId: (0, field_1.optionalNullableString)('Dealer id'),
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    model: (0, field_1.optionalNullableString)('Legacy model code'),
    lat: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    lon: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    region: (0, field_1.optionalNullableString)('Macro-region code'),
    registrationToken: (0, field_1.optionalNullableString)('Registration token'),
    protocolVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }).annotations({
        description: 'Stored as a number. Register writes 1 or 2; a later update can store 3. Absent or null on older records.',
    }),
    swVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    status: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Legacy status bag; keys and JSON values vary across historical Cosmos records',
    }),
    properties: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Opt-in raw device properties; keys and JSON values vary by model and firmware',
    }),
    metaData: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }).annotations({
        description: 'Opt-in raw metadata; keys and JSON values are user-defined',
    }),
    accountNumber: (0, field_1.optionalNullableString)('Dealer account number'),
    installationAddress: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.InstallationAddress), { exact: true }),
    contactInfo: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.ContactInfo), { exact: true }),
    createdAt: recordTimestamp('Creation time. An ISO-8601 string, epoch milliseconds, or null on an unregistered v1 device.'),
    registeredAt: recordTimestamp('Registration time. An ISO-8601 string, epoch milliseconds on a v2 device, or null when the device is unregistered.'),
    updatedAt: recordTimestamp('Last update time. An ISO-8601 string, epoch milliseconds, or null on an unregistered v1 device.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Device`,
    description: 'Legacy v1 admin registry projection',
});
exports.DevicePage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Device),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Engine pagination metadata, when present',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DevicePage`,
});
const registryWriteFields = {
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    ownerId: (0, field_1.optionalString)('Owner user id'),
    name: (0, field_1.optionalString)('Device display name'),
    lat: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    lon: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    uuid: (0, field_1.optionalString)('Correlation id; never stored. Only the Svix webhook routes use it, as the id of the ' +
        'acknowledgement they emit; a 32-character id is generated when omitted.'),
    dealerId: (0, field_1.optionalString)('Dealer id'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Manufacturing serial number'),
    sku: (0, field_1.optionalString)('Device SKU'),
    accountNumber: (0, field_1.optionalString)('Dealer account number'),
    address: (0, field_1.optionalString)('Street address'),
    addressExtra: (0, field_1.optionalString)('Additional address line'),
    zip: (0, field_1.optionalString)('Postal code'),
    city: (0, field_1.optionalString)('City'),
    state: (0, field_1.optionalString)('State or province'),
    country: (0, field_1.optionalString)('Country'),
    countryCode: (0, field_1.optionalString)('Country code'),
    mobilePhoneNumber: (0, field_1.optionalString)('Deprecated alias stored as contactInfo.phoneNumber'),
    phoneNumber: (0, field_1.optionalString)('Contact phone number'),
    email: (0, field_1.optionalString)('Contact email'),
    contactName: (0, field_1.optionalString)('Contact name'),
    customerAccountId: (0, field_1.optionalString)('Customer account id'),
};
exports.RegistryCreatePayload = effect_1.Schema.Struct({
    ...registryWriteFields,
    model: (0, field_1.optionalString)('Legacy model code; when supplied it must match the serial number'),
    registrationToken: (0, field_1.optionalString)('Registration token'),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryCreatePayload`,
    description: 'Creates a legacy v1 device. name is optional at runtime despite being required by the old Swagger schema.',
});
exports.RegistryUpdatePayload = effect_1.Schema.Struct({
    ...registryWriteFields,
    ownerId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString.annotations({ description: 'Owner user id; an empty string is rejected' }), { exact: true }).annotations({ description: 'Owner user id; an empty string is rejected' }),
    tenantId: (0, field_1.optionalString)('Tenant id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryUpdatePayload`,
    description: 'Shared by admin PUT and PATCH and by the three Svix customer-assignment webhooks. Unless both lat and lon are sent, the update geocodes them from address, zip, city, state, and country; a missing address or a failed lookup sets both to null. PUT then clears a null lat or lon and the matching providedLocation coordinates, while POST and PATCH leave the stored coordinates in place. PUT also clears an omitted dealerId, accountNumber, manufacturingSerialNumber, or sku, and always clears assetTag. Omitted name, ownerId and tenantId are kept. POST and PATCH preserve those omitted scalars. Every call rewrites installationAddress and providedLocation: omitted address fields are stored as null, and providedLocation is replaced. contactInfo is always written by PUT and is written by POST and PATCH only when a non-empty contact field is sent; omitted contact fields are stored as null.',
});
exports.SearchOperator = effect_1.Schema.Literal('equals', 'notEquals', 'in', 'notIn', 'gt', 'gte', 'lt', 'lte', 'stringEquals', 'stringContains', 'startsWith', 'endsWith', 'notStringEquals', 'notStringContains', 'notStartsWith', 'notEndsWith', 'listLengthEquals', 'notListLengthEquals', 'isDefined', 'notDefined', 'listContains', 'notListContains').annotations({
    identifier: `${exports.NAMESPACE}.SearchOperator`,
});
exports.SearchField = effect_1.Schema.Literal('accountNumber', 'contactInfo.customerAccountId', 'contactInfo.email', 'contactInfo.name', 'contactInfo.phoneNumber', 'dealerId', 'id', 'installationAddress.address', 'installationAddress.addressExtra', 'installationAddress.city', 'installationAddress.country', 'installationAddress.state', 'installationAddress.zip', 'metaData.annualService', 'metaData.extraDetails', 'model', 'name', 'ownerId', 'properties.annual_service_counter', 'properties.days_salt_remaining', 'properties.error_filter', 'properties.manual_salt_level_rem_calc', 'properties.unit_type', 'region.code', 'tenantId').annotations({
    identifier: `${exports.NAMESPACE}.SearchField`,
    description: 'Stored device fields accepted by the runtime where-clause allow-list',
});
const WhereLeaf = effect_1.Schema.Struct({
    field: effect_1.Schema.propertySignature(exports.SearchField),
    operator: effect_1.Schema.propertySignature(exports.SearchOperator),
    value: effect_1.Schema.optionalWith(Json.Value, { exact: true }),
    ignoreCase: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
});
const whereLevel = (child) => effect_1.Schema.Union(WhereLeaf, effect_1.Schema.Struct({ all: effect_1.Schema.Array(child).pipe(effect_1.Schema.minItems(1)) }), effect_1.Schema.Struct({ any: effect_1.Schema.Array(child).pipe(effect_1.Schema.minItems(1)) }));
// A bounded schema keeps Effect schema traversal and generated-client tooling
// finite. Runtime uses the same grammar and caps the complete tree at 200 nodes.
const WhereLevel1 = whereLevel(WhereLeaf);
const WhereLevel2 = whereLevel(WhereLevel1);
exports.WhereNode = whereLevel(WhereLevel2).annotations({
    identifier: `${exports.NAMESPACE}.WhereNode`,
    description: 'Nested AND/OR search condition. This contract exposes three group levels; runtime limits the complete tree to 200 nodes.',
});
exports.KeyValueFilter = effect_1.Schema.Struct({
    operator: effect_1.Schema.propertySignature(exports.SearchOperator),
    key: (0, field_1.nonEmpty)('Property or metadata key'),
    value: effect_1.Schema.optionalWith(Json.Value, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.KeyValueFilter`,
});
const BooleanLike = effect_1.Schema.Union(effect_1.Schema.Boolean, effect_1.Schema.Literal('true', 'false'), effect_1.Schema.Literal(0, 1));
const DateRange = effect_1.Schema.Struct({
    after: (0, field_1.optionalString)('Inclusive lower timestamp'),
    before: (0, field_1.optionalString)('Inclusive upper timestamp'),
});
const StringOrStrings = effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String));
const OneOrManyKeyValueFilters = effect_1.Schema.Union(exports.KeyValueFilter, effect_1.Schema.Array(exports.KeyValueFilter));
exports.SearchFilterParams = effect_1.Schema.Struct({
    name: (0, field_1.optionalString)('Device name'),
    model: effect_1.Schema.optionalWith(StringOrStrings, { exact: true }),
    swVersion: effect_1.Schema.optionalWith(Json.Value, { exact: true }),
    connected: effect_1.Schema.optionalWith(BooleanLike, { exact: true }),
    registered: effect_1.Schema.optionalWith(BooleanLike, { exact: true }),
    region: (0, field_1.optionalString)('Region code'),
    property: effect_1.Schema.optionalWith(OneOrManyKeyValueFilters, { exact: true }),
    metaData: effect_1.Schema.optionalWith(OneOrManyKeyValueFilters, { exact: true }),
    registeredAt: effect_1.Schema.optionalWith(DateRange, { exact: true }),
    updatedAt: effect_1.Schema.optionalWith(DateRange, { exact: true }),
    serialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    excludeSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    ownerId: (0, field_1.optionalString)('Owner user id'),
    email: (0, field_1.optionalString)('Owner email'),
    where: effect_1.Schema.optionalWith(effect_1.Schema.Union(exports.WhereNode, effect_1.Schema.Array(exports.WhereNode)), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.SearchFilterParams`,
});
exports.RegistrySearchPayload = effect_1.Schema.Struct({
    serialNumber: (0, field_1.optionalString)('Device serial number; minimum length 2 when truthy'),
    name: (0, field_1.optionalString)('Device name; minimum length 2 when truthy'),
    model: effect_1.Schema.optionalWith(StringOrStrings, { exact: true }).annotations({
        description: 'One or more legacy model codes; each must have minimum length 2 when truthy',
    }),
    ownerId: (0, field_1.optionalString)('Owner user id; minimum length 2 when truthy'),
    dealerId: effect_1.Schema.optionalWith(StringOrStrings, { exact: true }).annotations({
        description: 'One or more dealer ids; each must have minimum length 2 when truthy',
    }),
    tenantId: (0, field_1.optionalString)('Tenant id; minimum length 2 when truthy'),
    registered: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }),
    online: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }),
    region: (0, field_1.optionalString)('Region code (2–5 characters at runtime)'),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.String)), { exact: true }),
    installationAddress: (0, field_1.optionalString)('Address search text; minimum length 3'),
    filterId: (0, field_1.optionalString)('Stored filter id; takes precedence over filterParams and inline fields'),
    filterParams: effect_1.Schema.optionalWith(exports.SearchFilterParams, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistrySearchPayload`,
    description: 'POST registry/search body. The router merges query then body, so body values win on collisions.',
});
const filterFields = {
    name: (0, field_1.nonEmpty)('Filter name'),
    params: effect_1.Schema.propertySignature(exports.SearchFilterParams),
    acl: effect_1.Schema.optionalWith(effect_1.Schema.Literal('private', 'shared'), { exact: true }).annotations({
        description: 'Defaults to private on create',
    }),
    description: (0, field_1.optionalString)('Filter description'),
    category: (0, field_1.optionalString)('Filter category'),
};
exports.FilterCreatePayload = effect_1.Schema.Struct(filterFields).annotations({
    identifier: `${exports.NAMESPACE}.FilterCreatePayload`,
});
exports.FilterUpdatePayload = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Filter id'),
    ...filterFields,
}).annotations({
    identifier: `${exports.NAMESPACE}.FilterUpdatePayload`,
});
exports.FilterDeletePayload = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Filter id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.FilterDeletePayload`,
});
exports.Filter = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Filter id'),
    type: effect_1.Schema.Literal('filter'),
    name: (0, field_1.nonEmpty)('Filter name'),
    userId: (0, field_1.nonEmpty)('Author user id'),
    acl: effect_1.Schema.optionalWith(effect_1.Schema.Literal('private', 'shared'), { exact: true }).annotations({
        description: 'Absent when an update omitted it. Create stores private when omitted.',
    }),
    params: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Stored request object. The runtime only checks that params is an object.',
    }),
    description: effect_1.Schema.NullOr(effect_1.Schema.String),
    category: effect_1.Schema.NullOr(effect_1.Schema.String),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Filter`,
});
exports.FilterList = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Filter),
}).annotations({
    identifier: `${exports.NAMESPACE}.FilterList`,
});
//# sourceMappingURL=schema.js.map